import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Card, CardContent, Grid, TextField, Typography, Container, CssBaseline, InputLabel, styled, IconButton, InputAdornment } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Toast } from "@egovernments/digit-ui-react-components";
import { TLService } from "../../../../../../libraries/src/services/elements/TL";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    height: 25,
  },
  "& .MuiOutlinedInput-input": {
    padding: "5px",
    fontSize: "12px",
  },
  // marginBottom: "10px",
  width: "100%",
}));

const useStyles = makeStyles((theme) => ({
  root: {
    //height: '100vh',
    backgroundImage:
      "linear-gradient(#00000070,#0000007d), url('https://abmhosting.in/fastpass/loginpage1/images/sidebar.jpg') center center / cover no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    objectFit: "cover",
    imageRendering: "auto",
    opacity: ".85",
    border: "1.5px solid #fff",
  },
  overlay: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)", // Adjust the opacity (last value) as needed
  },
  card: {
    padding: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    border: "2px 0px 2px 2px",
    width: "370px",
    backgroundSize: "",
  },
  logo: {
    width: "110px",
    height: "85px",
  },
  header: {
    // marginBottom: "10px",
    textDecoration: "dense",
    color: "#fff",
  },
  textField: {
    // marginBottom: "5px",
    borderRadius: "1px",
    backgroundColor: "#fff",
    // border: '1px solid #ccc',
  },
  button: {
    // marginTop: "10px",
    width: "100px",
    height: "30px",
    borderRadius: "1px",
    backgroundColor: "#303F9F",
    color: "#fff",
    marginLeft: "32%",
  },
  label: {
    fontSize: "14px",
    color: "#fff",
  },
  p: {
    color: "#B07200",
    marginTop: "2px",
    fontSize: "10px",
    fontWeight: "600",
  },
}));

const EmployeeLoginCard = ({ handleFlip, flipped }) => {
  const classes = useStyles();
  const tenantId = Digit.ULBService.getStateId();
  const [showPassword,setShowPassword]=useState(false);
  const setEmployeeDetail = (userObject, token) => {
    let locale = JSON.parse(sessionStorage.getItem("Digit.locale"))?.value || "en_IN";
    localStorage.setItem("Employee.tenant-id", userObject?.tenantId);
    localStorage.setItem("tenant-id", userObject?.tenantId);
    localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
    localStorage.setItem("locale", locale);
    localStorage.setItem("Employee.locale", locale);
    localStorage.setItem("token", token);
    localStorage.setItem("Employee.token", token);
    localStorage.setItem("user-info", JSON.stringify(userObject));
    localStorage.setItem("Employee.user-info", JSON.stringify(userObject));
  };
  const { data: storeData, isLoading: isStoreLoading } = Digit.Hooks.useStore.getInitData();
  const { stateInfo } = storeData || {};
  const [error, setError] = useState("");
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [user, setUser] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [disable, setDisable] = useState(true);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaId, setCaptchaId] = useState("");

  const history = useHistory();

  const handleTogglePassword = () => {
  setShowPassword(prev => !prev);
};

  useEffect(() => {
    if (!user) {
      return;
    }
    Digit.SessionStorage.set("citizen.userRequestObject", user);
    const filteredRoles = user?.info?.roles?.filter((role) => role.tenantId === Digit.SessionStorage.get("Employee.tenantId"));
    if (user?.info?.roles?.length > 0) user.info.roles = filteredRoles;
    Digit.UserService.setUser(user);
    setEmployeeDetail(user?.info, user?.access_token);
    let redirectPath = "/digit-ui/employee";

    if (window?.location?.href?.includes("from=")) {
      redirectPath = decodeURIComponent(window?.location?.href?.split("from=")?.[1]) || "/digit-ui/employee";
    }

    if (user?.info?.roles && user?.info?.roles?.every((e) => e.code === "NATADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    }

    if (user?.info?.roles && user?.info?.roles?.every((e) => e.code === "STADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/home";
    }

    history.replace(redirectPath);
  }, [user]);

  useEffect(() => {
    generateCaptcha();
  }, []);
  const generateServerCaptcha = async () => {
    const captchaResult = await Digit.UserService.captchaGenerate(tenantId);
    if (captchaResult?.CaptchaResponse?.imageBase64) {
      setCaptchaImage(`data:image/png;base64,${captchaResult.CaptchaResponse.imageBase64}`);
    }
    if (captchaResult?.CaptchaResponse?.captchaId) {
      setCaptchaId(captchaResult.CaptchaResponse.captchaId);
    }
  };
  const validateCaptcha = async () => {
    const req = {
      captchaId: captchaId,
      userInput: watch("captcha"),
    };

    try {
      const captchaResult = await Digit.UserService.captchaValidate(tenantId, { CaptchaValidationRequest: req });

      // Check if there's an error in the response
      if (captchaResult?.CaptchaResponse?.error) {
        return captchaResult.CaptchaResponse.error; // Return error message
      }

      // If no error and image is present, update captcha image
      if (captchaResult?.CaptchaResponse?.imageBase64) {
        setCaptchaImage(`data:image/png;base64,${captchaResult.CaptchaResponse.imageBase64}`);
      }

      return captchaResult;
    } catch (error) {
      // Handle unexpected exceptions (network issues, etc.)
      return error.response.data.message || "Captcha validation failed"; // Return a generic error message
    }
  };

  // useEffect(() => {
  //   if (captcha === captchaInput) {
  //     setDisable(false);
  //   } else {
  //     setDisable(true);
  //   }
  // }, [captcha, captchaInput]);

  useEffect(() => {
    generateServerCaptcha();
  }, []);

  const generateCaptcha = () => {
    const randomCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(randomCaptcha);
    setCaptchaInput("");
  };
  const trackEscalteApplication = async () => {
    const result = await TLService.workflowEsclate();
  };
  // useEffect(() => {
  //   trackEscalteApplication();
  // }, []);

  const onLogin = async (data) => {
    // if (captcha !== captchaInput) {
    //   setShowToast({ error: true, message: `Invalid CAPTCHA` });
    //   setTimeout(closeToast, 5000);
    //   return;
    // }
    const captchaResult = await validateCaptcha();
    console.log(captchaResult, "ccaappttcchhrress");

    if (captchaResult?.isSuccessful === "Success") {
      setDisable(true);
      const requestData = {
        username: data?.employeeId,
        password: data?.empword,
        userType: "EMPLOYEE",
      };
      requestData.tenantId = tenantId;
      delete requestData.city;
      try {
        const { UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
        Digit.SessionStorage.set("Employee.tenantId", info?.tenantId);
        setUser({ info, ...tokens });
      } catch (err) {
        generateServerCaptcha();
        const errorMessage =
          err?.response?.data?.error_description || // ✅ Specific to your API structure
          err?.response?.data?.error || // Fallback if description isn't available
          "Invalid Login Credential"; // Final fallback
        setError(errorMessage);
        setShowToast({ error: true, message: errorMessage });
        setInvalidLogin(true);
        setTimeout(closeToast, 5000);
      }
      setDisable(false);
    } else {
      setInvalidLogin(true);
      setError(captchaResult);
      generateServerCaptcha();
      setShowToast({ error: true, message: `Captcha validation failed` });
    }
  };

  const closeToast = () => {
    setShowToast(null);
  };

  const onForgotPassword = () => {
    history.push("/digit-ui/employee/user/forgot-password-recover");
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <form autoComplete="off" onSubmit={handleSubmit(onLogin)}>
        <input type="text" name="fake_username" autoComplete="username" style={{ display: "none" }} />
  <input type="password" name="fake_password" autoComplete="current-password" style={{ display: "none" }} />
      <div>
        <Typography
          component="h6"
          align="center"
          style={{ fontWeight: "600", fontFamily: "sans-serif", lineHeight: "24px", letterSpacing: ".5px" }}
          className={classes.header}
        >
          EMPLOYEE LOGIN
        </Typography>
        <h3 className={classes.label}>Enter Employee ID</h3>
        <StyledTextField
          {...register("employeeId", {
            required: "Employee ID is required",
          })}
          margin="dense"
          variant="outlined"
          required
          fullWidth
          id="employeeId"
          name="employeeId"
          autoFocus
          autoComplete="off"
          size="small"
          placeholder="Enter Employee ID"
          className={classes.textField}
        />
        {errors.username && <p className={classes.p}>{errors.username.message}</p>}

        <h3 className={classes.label}>Enter Password</h3>
        <StyledTextField
  {...register("empword", {
    required: "Password is required",
    minLength: {
      value: 6,
      message: "Password must be at least 6 characters",
    },
  })}
  variant="outlined"
  required
  fullWidth
  margin="dense"
  name="empword"
  type={showPassword ? "text" : "password"}   // 👈 toggle type
  id="empword"
  autoComplete="off"
  className={classes.textField}
  placeholder="Enter Password"
  // InputProps={{
  //   endAdornment: (
  //     <InputAdornment position="end">
  //       <IconButton onClick={handleTogglePassword} edge="end">
  //         {showPassword ? <Visibility/>  : <VisibilityOff />}
  //       </IconButton>
  //     </InputAdornment>
  //   ),
  // }}
/>

        {errors.password && (
          // <Typography variant="caption" style={{ color: "yellow", marginTop: "2px", fontSize: "10px" }}>
          <p className={classes.p}>{errors.password.message}</p>
        )}
        <StyledTextField
          {...register("captcha", {
            required: "CAPTCHA is required",
            //validate: (value) => value === captcha || "CAPTCHA does not match",
          })}
          variant="outlined"
          margin="dense"
          fullWidth
          className={classes.textField}
          id="captcha"
          placeholder="Enter CAPTCHA"
          autoComplete="off"
          name="captcha"
        />

        {errors.captcha && (
          // <Typography variant="caption" style={{ color: "yellow",marginTop:"-2px", fontSize: "10px" }}>
          <p className={classes.p}>{errors.captcha.message}</p>
          // </Typography>
        )}
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <InputLabel className={classes.label} style={{ marginRight: "10px" }}>
            CAPTCHA:
          </InputLabel>

          {captchaImage && <img src={captchaImage} alt="CAPTCHA" style={{ height: "40px", marginRight: "10px" }} />}

          <IconButton onClick={generateServerCaptcha}>
            <CachedIcon style={{ color: "#fff" }} />
          </IconButton>
        </div>

        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.button}>
          Continue
        </Button>
        {/* {showToast && <Toast error={showToast?.error_description} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDleteBtn={true} />} */}
        {invalidLogin && (
          <p variant="caption" style={{ color: "red", marginTop: "10px", padding: "4px" }}>
            {error}
          </p>
        )}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
          <Typography
            component="div"
            align="center"
            onClick={onForgotPassword}
            sx={{
              cursor: "pointer",
              color: "#fff",
              "&:hover": {
                color: "#90caf9", // light blue on hover
                textDecoration: "none",
              },
            }}
          >
            Forgot Password?
          </Typography>
          <Typography
            onClick={handleFlip}
            component={"div"}
            align="center"
            sx={{
              cursor: "pointer",
              color: "#fff",
              "&:hover": {
                color: "#90caf9", // light blue on hover
                textDecoration: "none",
              },
            }}
          >
            {"Citizen Login"}
          </Typography>
        </div>
      </div>
      </form>
    </div>
  );
};

export default EmployeeLoginCard;
